import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const getMyTables = async () => {
  const response = await axios.get(routes.getMyTables, AXIOS_DEFAULT_CONFIG);
  return response;
};
export default getMyTables;
